export function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export async function withRetry(cb: () => Promise<void>, retry: number = 2) {
  try {
    const ret = await cb();
    return ret;
  } catch (error) {
    console.error("caught:", error);
    if (retry > 0) {
      await withRetry(cb, retry - 1);
    } else {
      throw error;
    }
  }
}
